import { Form, Formik, FormikHelpers } from "formik";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { WebCourseFormValues } from "src/models/WebCourse.model";
import { useEditWebcourseMutation } from "src/services/WebcourseServices";
import { showToast } from "src/utils/showToaster";
import { array, object, string } from "yup";
import BasicDeatilsCourse from "./BasicDetailsCourseForm";


const BasicDetailsCourseFormWrapper = () => {

  const [updateWebCourse] = useEditWebcourseMutation();

  const { id = '' } = useParams();
  const navigate = useNavigate();
  const { webCourseDataLayout }: any = useOutletContext();


  // Form Initial Values
  const initialValues: WebCourseFormValues = {
    type:
      webCourseDataLayout?.type ? {
        label: webCourseDataLayout?.type || '',
        value: webCourseDataLayout?.type || ''
      } : '',
    mode: webCourseDataLayout?.mode || '',
    expiryDate: webCourseDataLayout?.duration || '',
    courseName: webCourseDataLayout?.courseName || '',
    courseDescription: webCourseDataLayout?.shortDescription ? webCourseDataLayout?.shortDescription : '',
    longDescription: webCourseDataLayout?.longDescription ? webCourseDataLayout?.longDescription : '',

    imageThumbnail: webCourseDataLayout?.thumbNail || '',
    courseMrpPrice: webCourseDataLayout?.mrp || '',
    courseOfferPrice: webCourseDataLayout?.offerPrice || '',
    rating: webCourseDataLayout?.overallRating || '',
    instructor:
      webCourseDataLayout?.instructor?.map((el: any) => {
        return {
          label: el?.name || '',
          value: el?._id || ''
        }
      }) || [],
    videoPlatform: webCourseDataLayout?.videoPlatform || '',
    demoVideo: webCourseDataLayout?.videoLink || '',
    whatYouWillLearn: webCourseDataLayout?.learnings?.length ? webCourseDataLayout?.learnings : [''],
    pointer: webCourseDataLayout?.descriptionPoints ? webCourseDataLayout?.descriptionPoints : ''
  };

  // Validation Schema
  const validationSchema = object().shape({
    // courseName: string().required("Please enter course name"),
    type: object().required("Please select course type"),
    mode: string().test(
      'is-required-when-mcq',
      'Mode is required',
      function (value) {
        const { type } = this.parent;
        if (type?.value === 'LIVE') {
          return value !== undefined && value !== null;
        }
        return true;
      }
    ),
    expiryDate: string().test(
      'is-required-when-mcq',
      'Expriy date is required',
      function (value) {
        const { type } = this.parent;
        if (type?.value === 'RECORDED') {
          return value !== undefined && value !== null;
        }
        return true;
      }
    ),
    courseDescription: string().required("Please enter course description"),
    longDescription: string().required("Please enter course description"),
    // pointer: string().required("Please enter course description pointer"),
    imageThumbnail: string().required("Please enter image thumbnail"),
    instructor: array().min(1, "Please select tranier").required('Please select tranier'),
    videoPlatform: string().required("Please select platform"),
    demoVideo: string().url("Please enter a valid URL").required("Please upload link"),
    courseMrpPrice: string().required("Please enter course MRP price"),
    courseOfferPrice: string().required("offer price is required")
      .test(
        'is-greater-or-equal',
        'Offer Price should not be greater than MRP',
        function (value: any) {
          const { courseMrpPrice } = this.parent;
          return value <= Number(courseMrpPrice);
        }
      ),
  });

  // Handle Submit
  const handleSubmit = (
    values: WebCourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<WebCourseFormValues>
  ) => {
    const formatedValue = {
      type: values.type?.value || '',
      mode: values.mode || '',
      courseName: values.courseName || '',
      shortDescription: values.courseDescription || '',
      longDescription: values.longDescription || '',
      instructor: values?.instructor?.map((trainer: any) => trainer?.value) || [],
      thumbNail: values?.imageThumbnail,
      videoPlatform: values?.videoPlatform || '',
      videoLink: values.demoVideo || '',
      mrp: values.courseMrpPrice || 0,
      offerPrice: values.courseOfferPrice || 0,

      descriptionPoints: values?.pointer,
      duration: values.expiryDate || '',
      learnings: values.whatYouWillLearn || '',

    };

    updateWebCourse({ body: formatedValue, id: id }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          navigate(`/website-content/web-course/${id}/course-content`)
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className="h-full overflow-hidden contents">
          <BasicDeatilsCourse
            formikProps={formikProps}
          />
        </Form>
      )}
    </Formik>
  );
};

export default BasicDetailsCourseFormWrapper;
